module.exports = __webpack_public_path__ + "ea2a67f515d9992e998c6bc8a2199493.svg";